import React, { useState, useCallback } from 'react'
import { EmailSignUpCenter } from '../../styles/2024/HomeStyles'
import { P } from '../../styles/2024/TextStyles'

export default function Footer() {
  const [email, setEmail] = useState('')
  const [errorForm, setErrorForm] = useState(false)
  const [submitForm, setSubmitForm] = useState(false)

  const onHandleForm = useCallback(
    (e) => {
      e.preventDefault()
      const emailFormat = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
      if (!email || !email.match(emailFormat)) {
        setErrorForm(true)
        console.log('form failed')
        return
      }
      const baseUrl = process.env.REACT_APP_API_ENDPOINT_BASE || 'https://api.georgebrown.ca'
      fetch(`${baseUrl}/join-waiting-list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
        .then((response) => response.json())
        .then(setSubmitForm(true))
        .then((data) => {
          //console.log(data)
        })
    },
    [email],
  )
  const onInputChange = useCallback((e) => {
    const email = e.target.value
    setEmail(email)
  }, [])

  return (
    <div className='flex flex-col justify-center self-stretch py-10 mb-10 bg-almost-black max-w-[390px] lg:max-w-[1440px] lg:flex-row-reverse lg:flex-reverse'>
      <EmailSignUpCenter
        className='w-full z-10 pr-0 '
        hasError={errorForm}
        submitted={submitForm}
      >
        <form onSubmit={onHandleForm} className='justify-self-end items-start lg:items-end'>
          <div className='max-w-[480px] relative'>
            <label className='text-beige-yellow lg:relative lg:top-0'>
              Sign up to our mailing list to receive updates
            </label>
            <input
              id='email'
              type='text'
              name='name'
              placeholder='Enter Your Email'
              value={email}
              onChange={onInputChange}
              className='text-almost-black bg-beige-yellow placeholder-almost-black border border-almost-black'
            />
            <input
              id='submit'
              type='submit'
              value='Sign Up!'
              className='text-almost-black bg-comfort-green'
            />
            <div className='inline-error' id='inline-error'>
              Please enter a valid email address
            </div>
            <div id='submitted'>
              <span className='text-warm-orange'>Success!</span> You’re in!
            </div>
          </div>
        </form>
        <div className='flex justify-start pt-6 lg:justify-end lg:pr-[349px]'>
          <div className='flex'>
            <a
              href='https://www.instagram.com/sod_yes/'
              // target='_blank'
              rel='noreferrer'
            >
              <img src='/static/2024/svg/gram.svg' alt='instagram logo' className='pt-6 pr-6' />
            </a>
            <a
              href='https://www.tiktok.com/@designgbc'
              // target='_blank'
              rel='noreferrer'
            >
              <img src='/static/2024/svg/tiktok.svg' alt='tiktok logo' className='pt-6 ' />
            </a>
          </div>
        </div>
      </EmailSignUpCenter>
      <div className='lg:w-full'>
        <img
          loading='lazy'
          src='/static/2024/svg/yes-2024.svg'
          alt=''
          className='shrink-0 max-w-full aspect-[1.52] w-[200px] lg:aspect-[0]'
        />
        <P className='self-start text-beige-yellow lg:my-8'>
          George Brown College YEAR END SHOW YES!
          <br />
          Daniels Waterfront Campus
          <br />3 Lower Jarvis St, Toronto
        </P>
        <div className='flex gap-4 pr-7 mt-4'>
          <img
            loading='lazy'
            src='/static/2024/img/GBCLogo.png'
            alt=''
            className='shrink-0 max-w-full aspect-[1.52] w-[116px]'
          />
          <img
            loading='lazy'
            src='/static/2024/svg/sod.svg'
            alt=''
            className='shrink-0 my-auto max-w-full aspect-[12.5] w-[200px]'
          />
        </div>
      </div>
    </div>
  )
}
